import React, { useCallback, useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['María', 'Sofía', 'Camila', 'Valentina', 'Lucía', 'Martina', 'Julieta', 'Agustina', 'Catalina', 'Florencia', 'Micaela', 'Rocío'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'Bogotá', 'Lima', 'Santiago', 'Montevideo'];
export function SocialProofPopup() {
  const [popup, setPopup] = useState<{
    name: string;
    city: string;
  } | null>(null);
  const [exiting, setExiting] = useState(false);
  const show = useCallback(() => {
    const name = NAMES[Math.floor(Math.random() * NAMES.length)];
    const city = CITIES[Math.floor(Math.random() * CITIES.length)];
    setExiting(false);
    setPopup({
      name,
      city
    });
    setTimeout(() => {
      setExiting(true);
      setTimeout(() => setPopup(null), 300);
    }, 4000);
  }, []);
  useEffect(() => {
    const initial = setTimeout(show, 8000);
    const interval = setInterval(show, 30000);
    return () => {
      clearTimeout(initial);
      clearInterval(interval);
    };
  }, [show]);
  if (!popup) return null;
  return <div className={`fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:w-80 bg-white rounded-xl shadow-xl p-3 z-50 border border-salvia-light flex items-center gap-3 ${exiting ? 'toast-exit' : 'toast-enter'}`} data-id="element-164">
      <div className="bg-salvia-light p-2 rounded-full flex-shrink-0" data-id="element-165">
        <CheckCircle2 className="w-5 h-5 text-salvia" data-id="element-166" />
      </div>
      <div data-id="element-167">
        <p className="text-sm font-medium text-gray-900 leading-tight" data-id="element-168">
          {popup.name} de {popup.city}
        </p>
        <p className="text-xs text-gray-500 mt-0.5" data-id="element-169">
          compró el Protocolo Endo-Rescate
        </p>
      </div>
    </div>;
}